import { getOpxHostApi } from 'owa-opx';
import { isThemeModeSetByHostApp } from './isThemeModeSetByHostApp';
import { loadTheme } from './loadTheme';
import { setCustomPalette } from '../mutators/setCustomPalette';
import { ThemeMode } from '../schema/ThemeMode';
import {
    getMiniHostAppDetail,
    updatePartialMiniHostAppDetail,
} from 'mini-host-bridge/lib/getMiniHostAppDetail';

export const onOpxThemeChange = async (isDarkTheme: boolean): Promise<void> => {
    const opxPalette = await getOpxHostApi().getOpxPalette(isDarkTheme);

    let themeMode: ThemeMode;
    if (isThemeModeSetByHostApp()) {
        themeMode = getMiniHostAppDetail().themeMode;
        // Update the host app detail locally
        updatePartialMiniHostAppDetail({
            isDarkTheme,
        });
    } else {
        themeMode = isDarkTheme ? ThemeMode.Dark : ThemeMode.Light;
    }

    setCustomPalette(opxPalette);
    loadTheme(themeMode);
};
